
import { Component, OnInit } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeSr from '@angular/common/locales/sr';

import { Playroom } from '../../models/playroom.model';
import { BirthdayZone } from '../../models/birthdayZone';
import { CalendarWeek } from '../../models/CalendarWeek';
import { CalendarSlotState } from '../../models/CalendarSlotState';
import { PlayroomService } from '../../services/playroom.service';
import { TimeSlotConfigurationService } from '../../services/time-slot-configuration.service';
import { ActivatedRoute, Router } from '@angular/router';
import { VisitorService } from '../../services/visitor.service';

registerLocaleData(localeSr);

@Component({
  selector: 'app-birthdate-booking',
  templateUrl: './birthdate-booking.component.html',
  styleUrls: ['./birthdate-booking.component.scss'],
})
export class BirthdateBookingComponent implements OnInit {
  playrooms: Playroom[] = [];
  zones: BirthdayZone[] = [];

  selectedRoomId: number | null = null;
  selectedZoneId: number | null = null;

  selectedDateISO = this.toISODateOnly(new Date());
  currentStartDate: Date = this.toMonday(new Date());

  calendarWeek: CalendarWeek | null = null;
  timeLabels: string[] = [];
  readonly state = CalendarSlotState;

  constructor(
    private playroomService: PlayroomService,
    private timeSlotService: TimeSlotConfigurationService,
    private router: Router,
     private visitorService: VisitorService,
      private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.playroomService.getAllPlayrooms();
    this.playroomService.playrooms$.subscribe(rooms => {
      this.playrooms = rooms ?? [];
      if (!this.selectedRoomId && this.playrooms.length) {
        this.selectedRoomId = this.playrooms[0].id;
        this.onRoomChanged();
      }
       this.route.queryParamMap.subscribe(params => {
      const roomIdParam       = params.get('roomId');
      const zoneIdParam       = params.get('zoneId');
      const appointmentParam  = params.get('appointmentDate'); 
      const hasQueryParams =
        !!roomIdParam || !!zoneIdParam || !!appointmentParam;
      if (roomIdParam) {
        this.selectedRoomId = +roomIdParam;
      }
      if (zoneIdParam) {
        this.selectedZoneId = +zoneIdParam;
      }
      if (appointmentParam) {
        this.selectedDateISO = appointmentParam;             
        this.currentStartDate = this.toMonday(new Date(appointmentParam));
      } else {
        this.currentStartDate = this.toMonday(new Date());
        this.selectedDateISO = this.toISODateOnly(this.currentStartDate);
      }
      if (hasQueryParams) {
        this.loadCalendar();  
      } 
    });
  });

    this.currentStartDate = this.toMonday(new Date());
    this.timeLabels = this.buildTimeLabels();
 
 
 
  }

onRoomChanged(): void {
  this.calendarWeek = null;
  this.zones = [];
  this.selectedZoneId = null;

  if (!this.selectedRoomId) return;

  const room = this.playrooms.find(r => r.id === this.selectedRoomId);
  if (!room) { 
    return;
  }

  const roomName = room.roomName ?? '';

  this.timeSlotService.getZonesByRoom(this.selectedRoomId, roomName).subscribe({
    next: zs => {
      this.zones = zs ?? [];
      this.selectedZoneId = this.zones[0]?.id ?? null; 
      this.loadCalendar();
    },
    error: err => console.error(err)
  });
}


  onZoneChanged(): void {
    this.calendarWeek = null;
    if (this.isReady()) this.loadCalendar();
  }

  onDateChanged(): void {
    const d = new Date(this.selectedDateISO);
    this.currentStartDate = this.toMonday(d);
    if (this.isReady()) this.loadCalendar();
  }

  loadCalendar(): void {
    if (!this.isReady()) return;
    this.timeSlotService
      .getCalendarWithAppointments(this.currentStartDate, this.selectedRoomId!, this.selectedZoneId!)
    .subscribe({
      next: (wc) => {
        this.calendarWeek = wc;
      },
      error: (err) => console.error(err)
    });
}

  isReady(): boolean {
    return !!(this.selectedRoomId && this.selectedZoneId);
  }

  onToday(): void {
    this.currentStartDate = this.toMonday(new Date());
    this.selectedDateISO = this.toISODateOnly(this.currentStartDate);
    if (this.isReady()) this.loadCalendar();
  }
  prevWeek(): void {
    const d = new Date(this.currentStartDate);
    d.setDate(d.getDate() - 7);
    this.currentStartDate = this.toMonday(d);
    this.selectedDateISO = this.toISODateOnly(this.currentStartDate);
    if (this.isReady()) this.loadCalendar();
  }
  nextWeek(): void {
    const d = new Date(this.currentStartDate);
    d.setDate(d.getDate() + 7);
    this.currentStartDate = this.toMonday(d);
    this.selectedDateISO = this.toISODateOnly(this.currentStartDate);
    if (this.isReady()) this.loadCalendar();
  }

  private toMonday(d: Date): Date {
    const date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const day = date.getDay();
    const diff = (day === 0 ? -6 : 1 - day);
    date.setDate(date.getDate() + diff);
    return date;
  }

  private toISODateOnly(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  private buildTimeLabels(): string[] {
    
    const res: string[] = [];
    for (let h = 9; h < 24; h++) {
      const hh = String(h).padStart(2, '0');
      res.push(`${hh}:00`);
      res.push(`${hh}:30`);
    }
    res.push('00:00');
    return res;
  }

  isToday(dateIso: string): boolean {
    const d = new Date(dateIso), t = new Date();
    return d.getFullYear() === t.getFullYear() &&
           d.getMonth() === t.getMonth() &&
           d.getDate() === t.getDate();
  }

  formatDateOnly(dateStr: string): string {
    return new Date(dateStr).toLocaleDateString('sr-RS');
  }

  weekdaySrLatn(dateIso: string): string {
    return new Date(dateIso).toLocaleDateString('sr-Latn-RS', { weekday: 'long' });
  }

  get monthYear(): string {
    if (!this.calendarWeek?.weekStart) return '';
    return new Date(this.calendarWeek.weekStart)
      .toLocaleDateString('sr-Latn-RS', { month: 'long', year: 'numeric' });
  }

  private convertLocalTimeToUtc(dateIso: string, localTime: string): string {
    // Kombinuje datum i lokalno vreme, konvertuje u UTC i vraća samo vreme
    const localDateTime = `${dateIso}T${localTime}:00`;
    const utcDate = new Date(localDateTime);
    const hours = String(utcDate.getUTCHours()).padStart(2, '0');
    const minutes = String(utcDate.getUTCMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  private fromUtcToLocal(utcDateStr: string): Date {
    // Osigurava da se UTC string pravilno tretira i konvertuje u lokalno vreme
    if (utcDateStr && !utcDateStr.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(utcDateStr)) {
      utcDateStr = utcDateStr + 'Z';
    }
    return new Date(utcDateStr);
  }
  
async openCardIfFree(day: { date: string; slots: any[]}, slotIndex: number) {
  const cell = day.slots?.[slotIndex];
 const id = day.slots?.[slotIndex]?.timeSlotConfigurationId ?? null;
  if (!cell || cell.state !== this.state.Generated) return;

  const timeLabel = this.timeLabels[slotIndex];
  const dayIso = String(day.date).slice(0, 10);
  
  // Konvertuj lokalno vreme u UTC pre slanja na server
  const utcTimeLabel = this.convertLocalTimeToUtc(dayIso, timeLabel);
  
  this.timeSlotService
    .resolveSlot(dayIso, this.selectedRoomId!, this.selectedZoneId, utcTimeLabel)
    .subscribe({
      next: ({ start, end }) => {
        // Konvertuj UTC vreme sa servera u lokalno vreme
        const toHHmm = (utcDateStr: string) => {
          const localDate = this.fromUtcToLocal(utcDateStr);
          return localDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false });
        };

        const blockStart = toHHmm(start);
        const blockEnd   = toHHmm(end);

        const roomObj = (this.playrooms ?? []).find(p => p.id === this.selectedRoomId);
        const zoneObj = (this.zones ?? []).find(z => z.id === this.selectedZoneId);

        const queryParams = {
          AppointmentDate: dayIso,
          startTimeBirthday: blockStart,
          endTimeBirthday: blockEnd,
          roomId: this.selectedRoomId ?? null,
          roomName: roomObj?.roomName ?? '',
          zoneId: this.selectedZoneId ?? null,
          zoneName: zoneObj?.zoneName ?? '',
          address: roomObj?.address ?? '',
          timeSlotConfigurationId: id ?? ''
        };
          console.log("queryParams-BOOKing", queryParams )
        const tree = this.router.createUrlTree(['admin/visitors-card-from-booking'], { queryParams });
        const url = this.router.serializeUrl(tree);
        window.open(url, '_blank');
      },
      error: err => {
        console.error('Resolve failed:', err);
      }
    });
}

onCellClick(day: { date: string; slots: any[] }, slotIndex: number) {
  const cell = day.slots?.[slotIndex];
  if (!cell || (cell.state !== this.state.Booked && cell.state !== this.state.Reserved)) return;

  const savedTimeSlotId: number | null =
    Number(cell?.savedTimeSlotId ?? cell?.timeSlotConfigurationId ?? null);

  if (!savedTimeSlotId) {
    console.warn('Nema savedTimeSlotId u ćeliji.', cell);
    return;
  }

  this.visitorService.getSavedTimeSlotByBirthdayId(savedTimeSlotId).subscribe({
    next: (birthday) => {

    const tree = this.router.createUrlTree(
        ['/admin/birthday-edit-from-form-calendar'],
        {
          queryParams: {
            savedTimeSlotId,
            birthdayId: (birthday as any)?.id ?? null
          }
        }
      );

      const url = this.router.serializeUrl(tree);

      window.open(url, '_blank');
    },
    error: (err) => {
      console.error('Greška /by-birthday-slot/:', err);
    }
  });
}


}





